import * as yup from 'yup'
import useTrans from '../../../../../hooks/useTrans'
import { useSelector } from 'react-redux'
import { isRequiredField } from '../../../../../utils/servicegift'

export function getValidationSchema(tipologiaUtenteChiave) {
  const t = useTrans()
  const service_gift = useSelector((state) => state?.servicegift?.service_gift)

  const withRequired = (chiave, yupObject) => {
    if (isRequiredField(service_gift, tipologiaUtenteChiave, 'checkout', chiave)) {
      return yupObject.required(t('Questo campo è obbligatorio')).nullable()
    }

    return yupObject.nullable()
  }

  return yup.object({
    utente: yup.object({
      telefono: withRequired(
        'utente.telefono',
        yup.string().min(8, t('Minimo {0} caratteri', [8]))
      ),
    }),
    anagrafica_azienda: yup.object({
      ragione_sociale: withRequired('anagrafica_azienda.ragione_sociale', yup.string()),
      telefono: withRequired(
        'anagrafica_azienda.telefono',
        yup.string().min(8, t('Minimo {0} caratteri', [8]))
      ),
      cod_fiscale: withRequired('anagrafica_azienda.cod_fiscale', yup.string()),
      partita_iva: withRequired(
        'anagrafica_azienda.partita_iva',
        yup.string().max(11, t('Massimo {0} caratteri', [11]))
      ),
      email: withRequired(
        'anagrafica_azienda.email',
        yup.string().email(t("L'email deve essere valida"))
      ),
    }),
  })
}
